
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Kalyaninagartomumbaitaxi() {



    const cardData =
    {
        keyword: ' Kalyani Nagar to Mumbai Taxi',
        heading: 'Prince Cabs: Kalyani Nagar to Mumbai Taxi',
        headingDescription: 'Prince Cabs offers reliable Kalyani Nagar to Mumbai Taxi services, perfect for airport transfers, corporate travel, family trips, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride from Kalyani Nagar to Mumbai via the expressway. With professional chauffeurs, on-time pickups, and transparent fares, we make your journey smooth and stress-free. Choose Prince Cabs’ trusted taxi service from Kalyani Nagar to Mumbai for comfort, convenience, and affordability.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. The site is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. At sunset, the arch glows beautifully against the skyline. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km crescent-shaped boulevard along the Arabian Sea. Locals and tourists flock here for evening walks, sea breezes, and stunning sunsets. At night, its streetlights resemble a sparkling necklace. During monsoon, waves dramatically crash against the promenade. It reflects the modern, vibrant spirit of Mumbai. Marine Drive is the heart of the city’s leisure life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage railway station built in 1887. Its Gothic Revival architecture features domes, spires, stained glass windows, and intricate carvings. The building looks spectacular when illuminated at night. It is both a functional transport hub and a heritage monument. Tourists admire its grandeur while witnessing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s blend of history and modernity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating to the 5th–6th centuries. The highlight is the magnificent Trimurti sculpture of Lord Shiva. The caves reflect India’s ancient artistry and spiritual traditions. Accessible by ferry from Gateway of India, the island offers peace away from the city. Lush greenery surrounds the caves, enhancing their charm. It is a must-visit for history and culture lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, popular for street food and leisure walks. Vendors serve local delights like pav bhaji, bhel puri, and ice gola. Families gather in the evenings to enjoy the sea breeze and sunset. Bollywood celebrities residing nearby make it a star-spotting zone. The beach is lively with children playing and locals exercising. Juhu Beach is Mumbai’s vibrant coastal escape."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines, dedicated to Lord Ganesha. Built in 1801, it attracts devotees, celebrities, and politicians daily. The golden dome and beautifully carved wooden doors add grandeur. Tuesdays are especially crowded with worshippers. Devotees believe wishes made here are fulfilled. Siddhivinayak Temple is the spiritual core of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and an engineering marvel. It connects South Mumbai with the western suburbs, reducing travel time significantly. The bridge offers stunning views of the Arabian Sea and skyline. At night, its illuminated structure looks spectacular. Driving across the Sea Link is a thrilling experience. It is a modern symbol of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is a blend of spirituality and architecture. The dargah is connected by a causeway accessible at low tide. Devotees from all religions visit to seek blessings. Its sea-facing setting creates a serene atmosphere. Haji Ali is Mumbai’s iconic spiritual landmark."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market and shopping paradise. Visitors shop for clothes, handicrafts, jewelry, and antiques at bargain prices. Iconic cafés like Leopold Café and Café Mondegar add to the charm. The area is always lively with both locals and tourists. Bargaining with street vendors is part of the fun. Colaba Causeway is the ultimate shopping and cultural hotspot of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. Families and couples enjoy snacks like pav bhaji, kulfi, and bhel here. The beach is vibrant during evenings and festivals. It offers views of Marine Drive’s arc and the Arabian Sea. Children love playing in the sand and waves. Girgaon Chowpatty is Mumbai’s blend of tradition and leisure."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread over 500 acres. It has studios, artificial sets, and shooting zones for films and TV shows. Guided tours take visitors behind the scenes of movie production. Cinema lovers enjoy spotting live shoots. It is one of the largest film complexes in the world. Film City showcases Mumbai’s entertainment identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist stupas and rock-cut monasteries dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks. It is rare to find such nature in a metro. This park blends history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and skyscrapers. It is popular among birdwatchers, with species like herons and kingfishers often spotted. Joggers and photographers enjoy its promenade. During monsoon, the lake looks especially scenic with misty surroundings. It is a peaceful retreat within the bustling city. Powai Lake is Mumbai’s hidden natural gem."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the world’s largest meditation domes. Built in Burmese architectural style, it houses relics of Buddha. The golden dome accommodates thousands of meditators. Visitors attend meditation sessions and admire the grand design. Its seaside setting enhances tranquility. The pagoda symbolizes peace, spirituality, and harmony."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. Sky shows inside its dome theatre explain stars, galaxies, and cosmic wonders. The adjoining Science Centre offers interactive exhibits on innovation and technology. Families and students find it educational yet entertaining. Special events are held during eclipses and celestial events. It is Mumbai’s hub of science and curiosity."
  }
],

"services": [
  {
    "name": "Kalyani Nagar to Mumbai Cab Booking",
    "description": "Book reliable and comfortable cabs from Kalyani Nagar to Mumbai for all your travel needs. Whether it’s for business, leisure, or airport transfers, enjoy a hassle-free ride with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Kalyani Nagar to Mumbai Innova Taxi",
    "description": "Travel in style and comfort with our Innova taxi service from Kalyani Nagar to Mumbai. Perfect for families and groups seeking spacious interiors, premium features, and smooth long-distance journeys with courteous drivers."
  },
  {
    "name": "Kalyani Nagar to Mumbai Dzire Taxi",
    "description": "Affordable and efficient Dzire taxi services from Kalyani Nagar to Mumbai. Ideal for solo travelers or small groups, offering air-conditioned comfort and reliable transportation at competitive rates."
  },
  {
    "name": "Kalyani Nagar to Mumbai One Way Cab",
    "description": "Convenient one-way cab service from Kalyani Nagar to Mumbai for those who need flexible travel options. Ideal for airport drop-offs, business trips, or personal travel without worrying about return bookings."
  },
  {
    "name": "Kalyani Nagar to Mumbai Airport Taxi",
    "description": "Timely and comfortable airport taxi service from Kalyani Nagar to Mumbai International Airport. Our drivers ensure prompt pickups and smooth rides to catch your flights without stress."
  },
  {
    "name": "Kalyani Nagar to Mumbai Crysta Taxi",
    "description": "Premium Innova Crysta taxi service offering luxury travel from Kalyani Nagar to Mumbai. Spacious seating, plush interiors, and professional drivers make your journey enjoyable and relaxing."
  },
  {
    "name": "Kalyani Nagar to Mumbai Ertiga Cab",
    "description": "Book Ertiga cabs for economical yet comfortable travel from Kalyani Nagar to Mumbai. Suitable for families and groups who want ample space without compromising on affordability."
  },
  {
    "name": "Kalyani Nagar to Mumbai SUV Rental",
    "description": "Hire powerful and spacious SUVs from Kalyani Nagar to Mumbai for a comfortable ride over longer distances. Ideal for group travel, rugged routes, and travelers seeking extra comfort and style."
  },
  {
    "name": "Kalyani Nagar to Mumbai Family Cab",
    "description": "Family-friendly cab services from Kalyani Nagar to Mumbai, designed to provide safe and comfortable travel for families of all sizes. Vehicles are equipped to handle luggage and child seats if required."
  },
  {
    "name": "Affordable Taxi from Kalyani Nagar to Mumbai",
    "description": "Get affordable taxi options from Kalyani Nagar to Mumbai without compromising on comfort and safety. Well-maintained vehicles and professional drivers ensure a pleasant journey within your budget."
  },
  {
    "name": "Kalyani Nagar to Mumbai Tour Cab",
    "description": "Plan your tours with our reliable cab service from Kalyani Nagar to Mumbai. Whether it’s city sightseeing or corporate trips, enjoy flexible bookings and courteous drivers to make your travel smooth."
  },
  {
    "name": "Kalyani Nagar to Mumbai Etios Taxi",
    "description": "Economical and comfortable Etios taxi services from Kalyani Nagar to Mumbai. Perfect for travelers who want reliable and budget-friendly options with a focus on safety and punctuality."
  },
  {
    "name": "Kalyani Nagar to Mumbai Night Cab",
    "description": "Safe and secure night cab services from Kalyani Nagar to Mumbai with experienced drivers. Travel late at night with confidence and peace of mind in air-conditioned vehicles."
  },
  {
    "name": "Kalyani Nagar to Mumbai Round Trip Cab",
    "description": "Convenient round trip cab services from Kalyani Nagar to Mumbai offering flexible schedules, reliable pickups, and comfortable rides for business or leisure travelers."
  },
  {
    "name": "Kalyani Nagar to Mumbai Sedan Hire",
    "description": "Hire sedan cabs from Kalyani Nagar to Mumbai for smooth, comfortable rides. Choose from popular sedans like Dzire and Etios, ideal for small groups and business commuters."
  }
],
"tableData": [
  ["Kalyani Nagar to Mumbai Cab Booking", "Kalyani Nagar to Mumbai Innova Taxi"],
  ["Kalyani Nagar to Mumbai Dzire Taxi", "Kalyani Nagar to Mumbai One Way Cab"],
  ["Kalyani Nagar to Mumbai Airport Taxi", "Kalyani Nagar to Mumbai Crysta Taxi"],
  ["Kalyani Nagar to Mumbai Ertiga Cab", "Kalyani Nagar to Mumbai SUV Rental"],
  ["Kalyani Nagar to Mumbai Family Cab", "Affordable Taxi from Kalyani Nagar to Mumbai"],
  ["Kalyani Nagar to Mumbai Tour Cab", "Kalyani Nagar to Mumbai Etios Taxi"],
  ["Kalyani Nagar to Mumbai Night Cab", "Kalyani Nagar to Mumbai Round Trip Cab"],
  ["Kalyani Nagar to Mumbai Sedan Hire"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Kalyani Nagar to Mumbai Taxi Service",
    "WhyChoosedescription": "Prince Cabs offers a dependable and punctual taxi service from Kalyani Nagar, Pune to Mumbai. Whether you're traveling for business, leisure, or family visits, our service ensures a comfortable and smooth journey tailored to your schedule. With prompt pickups and door-to-door service, you can travel from the upscale neighborhood of Kalyani Nagar to any destination in Mumbai with ease."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from our fleet of clean and comfortable vehicles including sedans and SUVs such as Swift Dzire, Honda Amaze, Innova Crysta, and Ertiga. All taxis are air-conditioned and equipped to provide a spacious, relaxing, and safe ride from Kalyani Nagar to Mumbai."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Our taxi fares from Kalyani Nagar to Mumbai are transparent, competitive, and inclusive of all charges like fuel, tolls, driver allowances, and taxes. With no hidden fees, you get a clear understanding of your travel cost upfront. Flexible payment options such as UPI, credit/debit cards, net banking, and cash are available."
  },
  {
    "WhyChooseheading": "Flexible Booking and Cancellation Policies",
    "WhyChoosedescription": "Booking your taxi is easy and flexible via phone, WhatsApp, or our online platform. Receive instant confirmation and enjoy hassle-free cancellation and rescheduling policies, allowing you to adjust plans according to your convenience without stress."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers have extensive knowledge of the Pune to Mumbai route and prioritize your safety and comfort. They are polite, assist with luggage, and ensure a smooth and timely journey, making your travel experience pleasant and stress-free."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Taxis",
    "WhyChoosedescription": "Your safety is paramount. All vehicles are thoroughly cleaned and sanitized before each trip. Equipped with safety features such as seat belts and airbags, our taxis provide a secure and hygienic travel environment."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Your Convenience",
    "WhyChoosedescription": "Prince Cabs offers round-the-clock customer support to assist with bookings, itinerary changes, and any travel-related queries. Our dedicated team ensures your Kalyani Nagar to Mumbai taxi ride is seamless and worry-free."
  }
]


























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide taxi service from Kalyani Nagar to Mumbai?',
        answer: 'Yes, Prince Cabs offers reliable taxi services from Kalyani Nagar, Pune to Mumbai for both one-way and round trips.',
    },
    {
        question: 'What types of taxis are available from Kalyani Nagar to Mumbai?',
        answer: 'We provide a variety of taxis including Swift Dzire, Innova, Ertiga, and Tempo Traveller to cater to different group sizes and preferences.',
    },
    {
        question: 'How long does the taxi journey from Kalyani Nagar to Mumbai take?',
        answer: 'The journey usually takes approximately 3.5 to 4.5 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a one-way taxi from Kalyani Nagar to Mumbai?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip taxi bookings tailored to your needs.',
    },
    {
        question: 'Are taxis from Kalyani Nagar to Mumbai sanitized and well-maintained?',
        answer: 'Absolutely! All taxis are regularly cleaned, sanitized, and serviced for your safety and comfort.',
    },
    {
        question: 'What are the taxi fare charges for Kalyani Nagar to Mumbai?',
        answer: 'Taxi fares vary based on vehicle type and trip details. Contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a taxi from Kalyani Nagar to Mumbai?',
        answer: 'You can book through our website or by calling our customer support team for quick and easy booking.',
    },
];

const testimonials = [
    {
        name: "Mr. Rajesh Shinde",
        position: "Corporate Traveler",
        text: "Prince Cabs provided excellent taxi service from Kalyani Nagar to Mumbai. The driver was punctual and the car was comfortable.",
        image: "/img/testimonial/testimonial-thumb-kalyani-mumbai-1.png",
    },
    {
        name: "Ms. Neha Joshi",
        position: "Frequent Commuter",
        text: "I regularly use Prince Cabs taxis from Kalyani Nagar to Mumbai. Reliable service and clean vehicles every time.",
        image: "/img/testimonial/testimonial-thumb-kalyani-mumbai-2.png",
    },
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Kalyani Nagar to Mumbai Taxi",
  "description": "Book reliable and comfortable taxi service from Kalyani Nagar to Mumbai. Options include Innova, Dzire, Crysta, Ertiga, Sedan, SUV, and Night Cab. One Way, Round Trip, and Airport Drop available at affordable prices.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Kalyani Nagar",
      "addressRegion": "Pune, Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Kalyani Nagar to Mumbai Cab Booking",
    "Kalyani Nagar to Mumbai Innova Taxi",
    "Kalyani Nagar to Mumbai Dzire Taxi",
    "Kalyani Nagar to Mumbai One Way Cab",
    "Kalyani Nagar to Mumbai Airport Taxi",
    "Kalyani Nagar to Mumbai Crysta Taxi",
    "Kalyani Nagar to Mumbai Ertiga Cab",
    "Kalyani Nagar to Mumbai SUV Rental",
    "Kalyani Nagar to Mumbai Family Cab",
    "Affordable Taxi from Kalyani Nagar to Mumbai",
    "Kalyani Nagar to Mumbai Tour Cab",
    "Kalyani Nagar to Mumbai Etios Taxi",
    "Kalyani Nagar to Mumbai Night Cab",
    "Kalyani Nagar to Mumbai Round Trip Cab",
    "Kalyani Nagar to Mumbai Sedan Hire"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Kalyani Nagar to Mumbai Taxi | One Way, Airport, SUV & Sedan Cabs</title>
  <meta
    name="description"
    content="Book affordable taxi from Kalyani Nagar to Mumbai including Innova, Dzire, Crysta, Etios, Ertiga, SUV, and Sedan. One Way, Round Trip, Airport Pickup/Drop and Night Cab options available."
  />
  <meta
    name="keywords"
    content="Kalyani Nagar to Mumbai Cab Booking, Kalyani Nagar to Mumbai Innova Taxi, Kalyani Nagar to Mumbai Dzire Taxi, Kalyani Nagar to Mumbai One Way Cab, Kalyani Nagar to Mumbai Airport Taxi, Kalyani Nagar to Mumbai Crysta Taxi, Kalyani Nagar to Mumbai Ertiga Cab, Kalyani Nagar to Mumbai SUV Rental, Kalyani Nagar to Mumbai Family Cab, Affordable Taxi from Kalyani Nagar to Mumbai, Kalyani Nagar to Mumbai Tour Cab, Kalyani Nagar to Mumbai Etios Taxi, Kalyani Nagar to Mumbai Night Cab, Kalyani Nagar to Mumbai Round Trip Cab, Kalyani Nagar to Mumbai Sedan Hire"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/84.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kalyaninagartomumbaitaxi ;